export default __webpack_public_path__ + "static/media/sling.c0a211e3.png";